import React from 'react';
import {Button, Checkbox, Table, Visibility} from "semantic-ui-react";
import TableStyled from "./Table";
import SortIcon from "./components/SortIcon";
import Filter from "./components/Filter";
import TableCellValue from "./components/TableCellValue";
import {allStatuses} from "../../pages/parcels/form_v3/status";
import Loader from "../Loader/Loader";
import TableCellValueGrid from "./components/TableCellValueGrid";

const TableGrid = ({
                       totalCount,
                       columns,
                       summaries,
                       checkbox,
                       disableFilters,
                       updateFilter,
                       filters,
                       sort,
                       setSort,
                       rows,
                       setPage,
                       page,
                       rowCount,
                       selectedIds,
                       setAll,
                       setSelected,
                       filtersParams,
                       loading,
                       width,
                       infinityScroll,
                       striped,
                       isGrid,
                       options,
                       loadNextPart,
                       history,
                       isDictionary,
                       gridName,
                       reload,
                       canEditByRow
                   }) => {

    const filter = (column) => {
        let filterValue = isGrid ? (filters.find(f => f.fieldName === column.fieldName) || null) : (filters[column.fieldName] || null);
        return <Filter
            isGrid={isGrid}
            filterParams={isGrid ? options : (!filtersParams ? {} : (filtersParams[column.fieldName] || {}))}
            column={column}
            value={filterValue}
            disabled={disableFilters}
            onChange={(fieldName, value) => updateFilter(fieldName, value)}
            isDictionary={isDictionary}
        />
    }

    const tableRow = (row, selected) => {
        return <Table.Row
            key={row.id}
            className={!isDictionary ? `table-grid__row table-grid__row_${allStatuses[row.statusCode].color}` : ''}
        >
            {
                checkbox && <Table.Cell className='table-grid__checkbox_row'>
                    <Checkbox disabled={loading} checked={selected}
                              onChange={(name, {checked}) => setSelected(row.id, checked)}/>
                </Table.Cell>
            }
            {
                columns.map(col => {
                    return <Table.Cell
                        key={col.fieldName}
                        id='table-grid__text-style'
                        style={{maxWidth: col.maxWidth, minWidth: col.minWidth, width: 'auto'}}
                    >
                        {isGrid
                            ? <TableCellValueGrid
                                gridName={gridName}
                                column={col}
                                row={row}
                                history={history}
                                reload={reload}
                                canEditByRow={canEditByRow}
                            />
                            : <TableCellValue
                                column={col}
                                row={row}
                            />
                        }
                    </Table.Cell>
                })
            }
        </Table.Row>
    };

    const loader = loading ? <Table.Row className='loader-body'>
        <Table.Cell className='loader' colSpan={columns.length}>
            <Loader label={'Загрузка'} description={''}/>
        </Table.Cell>
    </Table.Row> : null;

    return (
        <div className='table-grid'>
            {(!infinityScroll || (summaries && summaries.length > 0)) && (
                <div className='table-grid__header'>
                    {(summaries && summaries.length > 0) && (<div className='table-grid__summary'>
                        {summaries.map((entry, index) => <span>{index > 0 ? ', ' : ''}{entry.name}: <b>{entry.value}</b></span>)}
                    </div>)}
                    {!infinityScroll && (<div className='table-grid__pagination' style={{ width: width }}>
                        <div>{1 + (page * rowCount) - rowCount}-{((page * rowCount) - rowCount) + rows.length} из {totalCount}</div>
                        <Button onClick={() => setPage(page - 1)} disabled={page === 1} icon={'angle left'} />
                        <Button onClick={() => setPage(page + 1)}
                            disabled={page === Math.ceil(totalCount / rowCount) || totalCount < rowCount}
                            icon={'angle right'} />
                    </div>)}
                </div>
            )}
            <div className='table-scroll'>
                <TableStyled striped={striped}>
                    <Table.Header style={{zIndex: loading && 10}}>
                        {isGrid && <Table.Row>
                            {
                                checkbox && <Table.HeaderCell className='col-name with-filter'/>
                            }
                            {
                                columns.map(col => (
                                    <Table.HeaderCell className='col-name with-filter' key={col.fieldName + 'name'}>
                                        {col.title}
                                    </Table.HeaderCell>
                                ))
                            }
                        </Table.Row>}
                        <Table.Row className={isGrid ? 'with-names' : ''}>
                            {
                                checkbox && <Table.HeaderCell className={`table-grid__checkbox ${isDictionary ? 'table-grid__checkbox_pl_8' : ''}`}>
                                    <Checkbox
                                        checked={(selectedIds.length > 0) && (selectedIds.length === totalCount)}
                                        onChange={(name, {checked}) => setAll(checked)}
                                    />
                                </Table.HeaderCell>
                            }
                            {
                                columns.map(col => (
                                    <Table.HeaderCell key={col.fieldName}>
                                        <div className='table-grid__filter'>
                                            {
                                                col.filterType ?
                                                    filter(col)
                                                    : col.title
                                            }
                                            {
                                                !col.disableSort && <div className='table-grid__sort-btn'
                                                                         onClick={() => setSort(col.fieldName)}>
                                                    <SortIcon
                                                        highlighted={(sort || {}).fieldName === col.fieldName}
                                                        isAsc={(sort || {}).fieldName === col.fieldName && (sort || {}).order === 'asc'}
                                                    />
                                                </div>
                                            }
                                        </div>
                                    </Table.HeaderCell>
                                ))
                            }
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {(loading && !infinityScroll) && loader}
                        {
                            (!loading || infinityScroll) && (rows && rows.map((row, i) => tableRow(row, !!selectedIds.includes(row.id), i === rows.length - 1)))
                        }
                    </Table.Body>
                </TableStyled>
                {infinityScroll && <Visibility
                    continuous={false}
                    once={false}
                    onTopVisible={() => {
                        loadNextPart();
                    }}
                    style={{bottom: 0, left: 0, right: 0, top: '-200px', position: 'relative'}}/>}
            </div>
        </div>
    );
};

export default TableGrid;


// WEBPACK FOOTER //
// ./App/components/Table/TableGrid.jsx